<script>
  import { onMount } from "svelte"
  import { navigate } from "svelte-routing"
  import { tweened } from "svelte/motion"
  import Footer from "../components/Footer.svelte"
  import Header from "../components/Header.svelte"
  import Sidebar from "../components/Sidebar.svelte"
  import { verifySession } from "../services/verifySession"
  import { user } from "../stores/User"
  import Alert from "../components/notificaciones/Alert.svelte"
  import { BASE_URL } from "../stores/BASE_URL"
  import Container from "../components/Container.svelte"

  onMount(() => {
    if (!$user) {
      navigate("/", { replace: true })
    } else {
      verifySession($user.session_key)

      //Pass
      if ($user.actualizar_clave == "1") {
        navigate("/seguridad", { replace: true })
      }

      //C
      if ($user.verificar == "1") {
        navigate("/verificar", { replace: true })
      }
    }
  })

  // Tiempo de sessión
  let original = 20 * 60
  let timer = tweened(original)

  setInterval(() => {
    if ($timer > 0) $timer--
  }, 1000)

  $: minutes = Math.floor($timer / 60)

  $: if (minutes <= 0) {
    user.setUser(null)
    navigate("/", { replace: true })
  }

  let notificaciones = []

  const getNotificaciones = async () => {
    let id_cliente = $user.id_cliente
    let session_key = $user.session_key
    let inicio_servicio = $user.inicio_servicio

    const response = await fetch(
      `${BASE_URL}notificacion.php?session_key=${session_key}&id_cliente=${id_cliente}&inicio_servicio=${inicio_servicio}`,
    )
    const resp = await response.json()

    if (resp.status == "ok") {
      notificaciones = resp.data
    } else {
      notificaciones = []
    }
  }

  const deleteNotificacion = (e) => {
    notificaciones = notificaciones.filter(
      (_, index) => index !== e.detail.index,
    )
  }

  getNotificaciones()
</script>

{#if $user}
  <main class="d-flex flex-column md:flex-row min-vh-100">
    <Sidebar />

    <div class="d-flex flex-column flex-grow-1 page-content">
      <Header />

      <div class="container-fluid bg-2 flex-grow-1">
        <div class="row h-100">
          <div
            class="col-12 {notificaciones.length > 0
              ? ' md:col-6 '
              : ' md:col-12 '} py-5"
          >
            <Container>
              <div
                class="bienvenido d-flex align-items-center justify-content-center"
              >
                <div>
                  <h3 class="fs-xl">
                    <span class="fg-secondary">Bienvenido </span>
                    {$user.nombres}
                  </h3>

                  <div class="text-center fg-secondary">
                    <p class="mt-5 mb-0">
                      Plan: {$user.plan}
                    </p>
                    <p class="mb-0">
                      Consultas contratadas: <span
                        >{Number($user.consultas_contrato).toLocaleString(
                          "es-PE",
                        )}</span
                      >
                    </p>
                    <p class="mb-0">
                      Consultas disponibles: <span>
                        {#if $user.plan.includes("Ilimitado")}
                          Ilimitado
                        {:else}
                          {Number(
                            $user.consultas - $user.consumo,
                          ).toLocaleString("es-PE")}
                        {/if}
                      </span>
                    </p>
                    <p class="">Vence: <span>{$user.fin}</span></p>
                  </div>
                </div>
              </div>
            </Container>
          </div>
          <div
            class="col-12 {notificaciones.length > 0
              ? ' md:col-6 '
              : ' md:col-12 '} py-5"
          >
            {#if notificaciones.length > 0}
              <Container>
                {#each notificaciones as { titulo, mensaje, tipo }, index}
                  <Alert
                    {index}
                    title={titulo}
                    message={mensaje}
                    {tipo}
                    cupon={String($user.id).padStart(6, "0")}
                    on:delete={deleteNotificacion}
                  />
                {/each}
              </Container>
            {/if}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  </main>
{/if}

<style>
  .page-content {
    min-width: 0;
  }

  /* Alto de la pantalla menos Header, separación del contenido y Footer. */
  .bienvenido {
    min-height: calc(100vh - (116px + 130px + 32px));
  }

  @media (max-width: 767.98px) {
    .bienvenido {
      min-height: 45vh;
    }
  }
</style>
